import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { ActivationComponent } from './activation/activation.component';
import { ChannelWatchComponent } from './channel/watch.component';
import { EPGComponent } from './channel/epg/epg.component';
import { HomeComponent } from './home/home.component';
import { PromoComponent } from './promo/promo.component';

// Guard
import { AuthorizationGuard } from './core/authorization.guard';

const routes: Routes = [
  { path: '', redirectTo: '/activation', pathMatch: 'full' },
  { path: 'activation', component: ActivationComponent },
  { path: 'channel/:id/watch', component: ChannelWatchComponent },
  { path: 'promo', component: PromoComponent},
  { path: 'home', canActivate: [AuthorizationGuard], component: HomeComponent }, // Usando canActivateChild //  path: 'home', component: HomeComponent },
  { path: 'epg', canActivate: [AuthorizationGuard],component: EPGComponent}, // Usando canActivateChild // path: 'epg', component: EPGComponent},
  { path: '**', redirectTo: '/activation'}, // joker route

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
